module.exports = __webpack_public_path__ + "img/coloring_logo.5cd2302c.png";